import React from "react";
import { useSearchParams } from "react-router-dom";

import Claims from "../../../components/claims/Claims";

const USERNAME_PREFIX_BY_PRODUCT: Record<string, string> = {
  indurama: "CE",
};

const ClaimsComponent = () => {
  const [searchParams] = useSearchParams();
  const product = searchParams.get("product") ?? "";
  // Case-insensitive: el product llega del slug del sponsor y puede variar en
  // mayúsculas; así el prefijo (ej. indurama -> "CE") no se rompe.
  const usernamePrefix = USERNAME_PREFIX_BY_PRODUCT[product.toLowerCase()];

  return (
    <section className="flex w-full justify-center p-0">
      <div className="container w-full px-4 py-20 lg:px-20">
        <div className="rounded-xl py-5 shadow-xl lg:px-10">
          <Claims colorPrimary="#2868D8" usernamePrefix={usernamePrefix} />
        </div>
      </div>
    </section>
  );
};

export default ClaimsComponent;
